export default "__VITE_ASSET__CIVc4T1R__"